/* eslint-disable */
export default {
  Home: 'Home',
  Mobile: 'Cellulare',
  Work: 'Lavoro',
} as const;

// @key: @#@"Home"@#@ @source: @#@"Home"@#@
// @key: @#@"Mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"Work"@#@ @source: @#@"Work"@#@
